import {
  Box,
  Divider,
  InputAdornment,
  InputBase,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  TextField as MuiTextField,
  TextFieldProps as MuiTextFieldProps,
  Popover,
  Stack
} from '@mui/material';
import { CaretDownIcon, MagnifyingGlassIcon } from '@phosphor-icons/react';
import { VirtualizedList } from '@repo/ui';
import 'flag-icons/css/flag-icons.min.css';
import React, { memo, useCallback, useMemo, useState } from 'react';
import { FormFieldApi } from '../types';

export const US_STATE_INFO = {
  "201": {
    "type": "local",
    "city": "Bayonne",
    "state": "New Jersey",
    "stateCode": "NJ",
    "country": "US"
  },
  "202": {
    "type": "local",
    "city": "Washington",
    "state": "District Of Columbia",
    "stateCode": "DC",
    "country": "US"
  },
  "203": {
    "type": "local",
    "city": "Bridgeport",
    "state": "Connecticut",
    "stateCode": "CT",
    "country": "US"
  },
  "204": {
    "type": "local",
    "city": "Winnipeg",
    "state": "Manitoba",
    "stateCode": "MB",
    "country": "CA"
  },
  "205": {
    "type": "local",
    "city": "Birmingham",
    "state": "Alabama",
    "stateCode": "AL",
    "country": "US"
  },
  "206": {
    "type": "local",
    "city": "Seattle",
    "state": "Washington",
    "stateCode": "WA",
    "country": "US"
  },
  "207": {
    "type": "local",
    "city": "Portland",
    "state": "Maine",
    "stateCode": "ME",
    "country": "US"
  },
  "208": {
    "type": "local",
    "city": "Boise",
    "state": "Idaho",
    "stateCode": "ID",
    "country": "US"
  },
  "209": {
    "type": "local",
    "city": "Lodi",
    "state": "California",
    "stateCode": "CA",
    "country": "US"
  },
  "210": {
    "type": "local",
    "city": "San Antonio",
    "state": "Texas",
    "stateCode": "TX",
    "country": "US"
  },
  "212": {
    "type": "local",
    "city": "New York City",
    "state": "New York",
    "stateCode": "NY",
    "country": "US"
  },
  "213": {
    "type": "local",
    "city": "Los Angeles",
    "state": "California",
    "stateCode": "CA",
    "country": "US"
  },
  "214": {
    "type": "local",
    "city": "Dallas",
    "state": "Texas",
    "stateCode": "TX",
    "country": "US"
  },
  "215": {
    "type": "local",
    "city": "Levittown",
    "state": "Pennsylvania",
    "stateCode": "PA",
    "country": "US"
  },
  "216": {
    "type": "local",
    "city": "Cleveland",
    "state": "Ohio",
    "stateCode": "OH",
    "country": "US"
  },
  "217": {
    "type": "local",
    "city": "Champaign",
    "state": "Illinois",
    "stateCode": "IL",
    "country": "US"
  },
  "218": {
    "type": "local",
    "city": "Duluth",
    "state": "Minnesota",
    "stateCode": "MN",
    "country": "US"
  },
  "219": {
    "type": "local",
    "city": "Gary",
    "state": "Indiana",
    "stateCode": "IN",
    "country": "US"
  },
  "220": {
    "type": "local",
    "city": "Athens",
    "state": "Ohio",
    "stateCode": "OH",
    "country": "US"
  },
  "223": {
    "type": "local",
    "city": "Lancaster",
    "state": "Pennsylvania",
    "stateCode": "PA",
    "country": "US"
  },
  "224": {
    "type": "local",
    "city": "Arlington Heights",
    "state": "Illinois",
    "stateCode": "IL",
    "country": "US"
  },
  "225": {
    "type": "local",
    "city": "Baton Rouge",
    "state": "Louisiana",
    "stateCode": "LA",
    "country": "US"
  },
  "226": {
    "type": "local",
    "city": "London",
    "state": "Ontario",
    "stateCode": "ON",
    "country": "CA"
  },
  "227": {
    "type": "local",
    "city": "Silver Spring",
    "state": "Maryland",
    "stateCode": "MD",
    "country": "US"
  },
  "228": {
    "type": "local",
    "city": "Biloxi",
    "state": "Mississippi",
    "stateCode": "MS",
    "country": "US"
  },
  "229": {
    "type": "local",
    "city": "Albany",
    "state": "Georgia",
    "stateCode": "GA",
    "country": "US"
  },
  "231": {
    "type": "local",
    "city": "Grant",
    "state": "Michigan",
    "stateCode": "MI",
    "country": "US"
  },
  "234": {
    "type": "local",
    "city": "Akron",
    "state": "Ohio",
    "stateCode": "OH",
    "country": "US"
  },
  "236": {
    "type": "local",
    "city": "Vancouver",
    "state": "British Columbia",
    "stateCode": "BC",
    "country": "CA"
  },
  "239": {
    "type": "local",
    "city": "Cape Coral",
    "state": "Florida",
    "stateCode": "FL",
    "country": "US"
  },
  "240": {
    "type": "local",
    "city": "Aspen Hill",
    "state": "Maryland",
    "stateCode": "MD",
    "country": "US"
  },
  "248": {
    "type": "local",
    "city": "Farmington Hills",
    "state": "Michigan",
    "stateCode": "MI",
    "country": "US"
  },
  "249": {
    "type": "local",
    "city": "Sudbury",
    "state": "Ontario",
    "stateCode": "ON",
    "country": "CA"
  },
  "250": {
    "type": "local",
    "city": "Kelowna",
    "state": "British Columbia",
    "stateCode": "BC",
    "country": "CA"
  },
  "251": {
    "type": "local",
    "city": "Mobile",
    "state": "Alabama",
    "stateCode": "AL",
    "country": "US"
  },
  "252": {
    "type": "local",
    "city": "Elizabeth City",
    "state": "North Carolina",
    "stateCode": "NC",
    "country": "US"
  },
  "253": {
    "type": "local",
    "city": "Kent",
    "state": "Washington",
    "stateCode": "WA",
    "country": "US"
  },
  "254": {
    "type": "local",
    "city": "Eastland",
    "state": "Texas",
    "stateCode": "TX",
    "country": "US"
  },
  "256": {
    "type": "local",
    "city": "Decatur",
    "state": "Alabama",
    "stateCode": "AL",
    "country": "US"
  },
  "260": {
    "type": "local",
    "city": "Fort Wayne",
    "state": "Indiana",
    "stateCode": "IN",
    "country": "US"
  },
  "262": {
    "type": "local",
    "city": "Kenosha",
    "state": "Wisconsin",
    "stateCode": "WI",
    "country": "US"
  },
  "263": {
    "type": "local",
    "city": "Montreal",
    "state": "Quebec",
    "stateCode": "QC",
    "country": "CA"
  },
  "267": {
    "type": "local",
    "city": "Levittown",
    "state": "Pennsylvania",
    "stateCode": "PA",
    "country": "US"
  },
  "269": {
    "type": "local",
    "city": "Allegan",
    "state": "Michigan",
    "stateCode": "MI",
    "country": "US"
  },
  "270": {
    "type": "local",
    "city": "Bowling Green",
    "state": "Kentucky",
    "stateCode": "KY",
    "country": "US"
  },
  "272": {
    "type": "local",
    "stateCode": "PA",
    "state": "Pennsylvania",
    "city": "Back Mountain",
    "country": "US"
  },
  "274": {
    "type": "local",
    "city": "Green Bay",
    "state": "Wisconsin",
    "stateCode": "WI",
    "country": "US"
  },
  "276": {
    "type": "local",
    "city": "Danville",
    "state": "Virginia",
    "stateCode": "VA",
    "country": "US"
  },
  "278": {
    "type": "local",
    "city": "ann arbor",
    "state": "michigan",
    "stateCode": "MI",
    "country": "US"
  },
  "279": {
    "type": "local",
    "stateCode": "CA",
    "state": "California",
    "city": "Arden-Arcade",
    "country": "US"
  },
  "281": {
    "type": "local",
    "city": "Baytown",
    "state": "Texas",
    "stateCode": "TX",
    "country": "US"
  },
  "283": {
    "type": "local",
    "city": "Cincinnati",
    "state": "Ohio",
    "stateCode": "OH",
    "country": "US"
  },
  "289": {
    "type": "local",
    "city": "Hamilton",
    "state": "Ontario",
    "stateCode": "ON",
    "country": "CA"
  },
  "301": {
    "type": "local",
    "city": "Aspen Hill",
    "state": "Maryland",
    "stateCode": "MD",
    "country": "US"
  },
  "302": {
    "type": "local",
    "city": "Dover",
    "state": "Delaware",
    "stateCode": "DE",
    "country": "US"
  },
  "303": {
    "type": "local",
    "city": "Aurora",
    "state": "Colorado",
    "stateCode": "CO",
    "country": "US"
  },
  "304": {
    "type": "local",
    "city": "Charleston",
    "state": "West Virginia",
    "stateCode": "WV",
    "country": "US"
  },
  "305": {
    "type": "local",
    "city": "Miami",
    "state": "Florida",
    "stateCode": "FL",
    "country": "US"
  },
  "306": {
    "type": "local",
    "city": "Saskatoon",
    "state": "Saskatchewan",
    "stateCode": "SK",
    "country": "CA"
  },
  "307": {
    "type": "local",
    "city": "Casper",
    "state": "Wyoming",
    "stateCode": "WY",
    "country": "US"
  },
  "308": {
    "type": "local",
    "city": "Kearney",
    "state": "Nebraska",
    "stateCode": "NE",
    "country": "US"
  },
  "309": {
    "type": "local",
    "city": "Bloomington",
    "state": "Illinois",
    "stateCode": "IL",
    "country": "US"
  },
  "310": {
    "type": "local",
    "city": "Los Angeles",
    "state": "California",
    "stateCode": "CA",
    "country": "US"
  },
  "312": {
    "type": "local",
    "city": "Chicago",
    "state": "Illinois",
    "stateCode": "IL",
    "country": "US"
  },
  "313": {
    "type": "local",
    "city": "Dearborn",
    "state": "Michigan",
    "stateCode": "MI",
    "country": "US"
  },
  "314": {
    "type": "local",
    "city": "Florissant",
    "state": "Missouri",
    "stateCode": "MO",
    "country": "US"
  },
  "315": {
    "type": "local",
    "city": "Syracuse",
    "state": "New York",
    "stateCode": "NY",
    "country": "US"
  },
  "316": {
    "type": "local",
    "city": "Wichita",
    "state": "Kansas",
    "stateCode": "KS",
    "country": "US"
  },
  "317": {
    "type": "local",
    "city": "Indianapolis",
    "state": "Indiana",
    "stateCode": "IN",
    "country": "US"
  },
  "318": {
    "type": "local",
    "city": "Bossier City",
    "state": "Louisiana",
    "stateCode": "LA",
    "country": "US"
  },
  "319": {
    "type": "local",
    "city": "Cedar Rapids",
    "state": "Iowa",
    "stateCode": "IA",
    "country": "US"
  },
  "320": {
    "type": "local",
    "city": "Alexandria",
    "state": "Minnesota",
    "stateCode": "MN",
    "country": "US"
  },
  "321": {
    "type": "local",
    "city": "Melbourne",
    "state": "Florida",
    "stateCode": "FL",
    "country": "US"
  },
  "323": {
    "type": "local",
    "city": "Los Angeles",
    "state": "California",
    "stateCode": "CA",
    "country": "US"
  },
  "325": {
    "type": "local",
    "city": "Abilene",
    "state": "Texas",
    "stateCode": "TX",
    "country": "US"
  },
  "326": {
    "type": "local",
    "city": "Dayton",
    "state": "Ohio",
    "stateCode": "OH",
    "country": "US"
  },
  "327": {
    "type": "local",
    "city": "Jonesboro",
    "state": "Arkansas",
    "stateCode": "AR",
    "country": "US"
  },
  "330": {
    "type": "local",
    "city": "Akron",
    "state": "Ohio",
    "stateCode": "OH",
    "country": "US"
  },
  "331": {
    "type": "local",
    "city": "Aurora",
    "state": "Illinois",
    "stateCode": "IL",
    "country": "US"
  },
  "332": {
    "type": "local",
    "stateCode": "NY",
    "state": "New York",
    "city": "Manhattan",
    "country": "US"
  },
  "334": {
    "type": "local",
    "city": "Auburn",
    "state": "Alabama",
    "stateCode": "AL",
    "country": "US"
  },
  "336": {
    "type": "local",
    "city": "Greensboro",
    "state": "North Carolina",
    "stateCode": "NC",
    "country": "US"
  },
  "337": {
    "type": "local",
    "city": "Lafayette",
    "state": "Louisiana",
    "stateCode": "LA",
    "country": "US"
  },
  "339": {
    "type": "local",
    "city": "Lynn",
    "state": "Massachusetts",
    "stateCode": "MA",
    "country": "US"
  },
  "340": {
    "type": "local",
    "city": "charlotte amalie",
    "state": "us virgin islands",
    "stateCode": "VI",
    "country": "US"
  },
  "341": {
    "type": "local",
    "city": "Oakland",
    "state": "California",
    "stateCode": "CA",
    "country": "US"
  },
  "343": {
    "type": "local",
    "city": "Ottawa",
    "state": "Ontario",
    "stateCode": "ON",
    "country": "CA"
  },
  "346": {
    "type": "local",
    "stateCode": "TX",
    "state": "Texas",
    "city": "Alvin",
    "country": "US"
  },
  "347": {
    "type": "local",
    "city": "Bronx",
    "state": "New York",
    "stateCode": "NY",
    "country": "US"
  },
  "351": {
    "type": "local",
    "city": "Haverhill",
    "state": "Massachusetts",
    "stateCode": "MA",
    "country": "US"
  },
  "352": {
    "type": "local",
    "city": "Gainesville",
    "state": "Florida",
    "stateCode": "FL",
    "country": "US"
  },
  "354": {
    "type": "local",
    "city": "Granby",
    "state": "Quebec",
    "stateCode": "QC",
    "country": "CA"
  },
  "360": {
    "type": "local",
    "city": "Bellingham",
    "state": "Washington",
    "stateCode": "WA",
    "country": "US"
  },
  "361": {
    "type": "local",
    "city": "Corpus Christi",
    "state": "Texas",
    "stateCode": "TX",
    "country": "US"
  },
  "364": {
    "type": "local",
    "city": "Owensboro",
    "state": "Kentucky",
    "stateCode": "KY",
    "country": "US"
  },
  "365": {
    "type": "local",
    "city": "Hamilton",
    "state": "Ontario",
    "stateCode": "ON",
    "country": "CA"
  },
  "367": {
    "type": "local",
    "city": "Quebec",
    "state": "Quebec",
    "stateCode": "QC",
    "country": "CA"
  },
  "368": {
    "type": "local",
    "city": "Calgary",
    "state": "Alberta",
    "stateCode": "AB",
    "country": "CA"
  },
  "369": {
    "type": "local",
    "city": "santa rosa",
    "state": "California",
    "stateCode": "CA",
    "country": "US"
  },
  "380": {
    "type": "local",
    "city": "Columbus",
    "state": "Ohio",
    "stateCode": "OH",
    "country": "US"
  },
  "385": {
    "type": "local",
    "city": "Ogden",
    "state": "Utah",
    "stateCode": "UT",
    "country": "US"
  },
  "386": {
    "type": "local",
    "city": "Daytona Beach",
    "state": "Florida",
    "stateCode": "FL",
    "country": "US"
  },
  "401": {
    "type": "local",
    "city": "Cranston",
    "state": "Rhode Island",
    "stateCode": "RI",
    "country": "US"
  },
  "402": {
    "type": "local",
    "city": "Columbus",
    "state": "Nebraska",
    "stateCode": "NE",
    "country": "US"
  },
  "403": {
    "type": "local",
    "city": "Calgary",
    "state": "Alberta",
    "stateCode": "AB",
    "country": "CA"
  },
  "404": {
    "type": "local",
    "city": "Atlanta",
    "state": "Georgia",
    "stateCode": "GA",
    "country": "US"
  },
  "405": {
    "type": "local",
    "city": "Midwest City",
    "state": "Oklahoma",
    "stateCode": "OK",
    "country": "US"
  },
  "406": {
    "type": "local",
    "city": "Billings",
    "state": "Montana",
    "stateCode": "MT",
    "country": "US"
  },
  "407": {
    "type": "local",
    "city": "Altamonte Springs",
    "state": "Florida",
    "stateCode": "FL",
    "country": "US"
  },
  "408": {
    "type": "local",
    "city": "Gilroy",
    "state": "California",
    "stateCode": "CA",
    "country": "US"
  },
  "409": {
    "type": "local",
    "city": "Beaumont",
    "state": "Texas",
    "stateCode": "TX",
    "country": "US"
  },
  "410": {
    "type": "local",
    "city": "Annapolis",
    "state": "Maryland",
    "stateCode": "MD",
    "country": "US"
  },
  "412": {
    "type": "local",
    "city": "Pittsburgh",
    "state": "Pennsylvania",
    "stateCode": "PA",
    "country": "US"
  },
  "413": {
    "type": "local",
    "city": "Chicopee",
    "state": "Massachusetts",
    "stateCode": "MA",
    "country": "US"
  },
  "414": {
    "type": "local",
    "city": "Milwaukee",
    "state": "Wisconsin",
    "stateCode": "WI",
    "country": "US"
  },
  "415": {
    "type": "local",
    "city": "San Francisco",
    "state": "California",
    "stateCode": "CA",
    "country": "US"
  },
  "416": {
    "type": "local",
    "city": "Toronto",
    "state": "Ontario",
    "stateCode": "ON",
    "country": "CA"
  },
  "417": {
    "type": "local",
    "city": "Springfield",
    "state": "Missouri",
    "stateCode": "MO",
    "country": "US"
  },
  "418": {
    "type": "local",
    "city": "Quebec",
    "state": "Quebec",
    "stateCode": "QC",
    "country": "CA"
  },
  "419": {
    "type": "local",
    "city": "Toledo",
    "state": "Ohio",
    "stateCode": "OH",
    "country": "US"
  },
  "423": {
    "type": "local",
    "city": "Chattanooga",
    "state": "Tennessee",
    "stateCode": "TN",
    "country": "US"
  },
  "424": {
    "type": "local",
    "city": "Beverly Hills",
    "state": "California",
    "stateCode": "CA",
    "country": "US"
  },
  "425": {
    "type": "local",
    "city": "Bellevue",
    "state": "Washington",
    "stateCode": "WA",
    "country": "US"
  },
  "430": {
    "type": "local",
    "city": "Longview",
    "state": "Texas",
    "stateCode": "TX",
    "country": "US"
  },
  "431": {
    "type": "local",
    "city": "Winnipeg",
    "state": "Manitoba",
    "stateCode": "MB",
    "country": "CA"
  },
  "432": {
    "type": "local",
    "city": "Midland",
    "state": "Texas",
    "stateCode": "TX",
    "country": "US"
  },
  "434": {
    "type": "local",
    "city": "Lynchburg",
    "state": "Virginia",
    "stateCode": "VA",
    "country": "US"
  },
  "435": {
    "type": "local",
    "city": "Cedar City",
    "state": "Utah",
    "stateCode": "UT",
    "country": "US"
  },
  "437": {
    "type": "local",
    "city": "Toronto",
    "state": "Ontario",
    "stateCode": "ON",
    "country": "CA"
  },
  "438": {
    "type": "local",
    "city": "Montreal",
    "state": "Quebec",
    "stateCode": "QC",
    "country": "CA"
  },
  "440": {
    "type": "local",
    "city": "Cleveland",
    "state": "Ohio",
    "stateCode": "OH",
    "country": "US"
  },
  "442": {
    "type": "local",
    "city": "Apple Valley",
    "state": "California",
    "stateCode": "CA",
    "country": "US"
  },
  "443": {
    "type": "local",
    "city": "Baltimore",
    "state": "Maryland",
    "stateCode": "MD",
    "country": "US"
  },
  "445": {
    "type": "local",
    "city": "Philadelphia",
    "state": "Pennsylvania",
    "stateCode": "PA",
    "country": "US"
  },
  "447": {
    "type": "local",
    "city": "Champaign",
    "state": "Illinois",
    "stateCode": "IL",
    "country": "US"
  },
  "450": {
    "type": "local",
    "city": "Granby",
    "state": "Quebec",
    "stateCode": "QC",
    "country": "CA"
  },
  "458": {
    "type": "local",
    "city": "Eugene",
    "state": "Oregon",
    "stateCode": "OR",
    "country": "US"
  },
  "463": {
    "type": "local",
    "stateCode": "IN",
    "state": "Indiana",
    "city": "Carmel",
    "country": "US"
  },
  "464": {
    "type": "local",
    "city": "Cicero",
    "state": "Illinois",
    "stateCode": "IL",
    "country": "US"
  },
  "468": {
    "type": "local",
    "city": "Sherbrooke",
    "state": "Quebec",
    "stateCode": "QC",
    "country": "CA"
  },
  "469": {
    "type": "local",
    "city": "Carrollton",
    "state": "Texas",
    "stateCode": "TX",
    "country": "US"
  },
  "470": {
    "type": "local",
    "city": "Atlanta",
    "state": "Georgia",
    "stateCode": "GA",
    "country": "US"
  },
  "474": {
    "type": "local",
    "city": "Saskatoon",
    "state": "Saskatchewan",
    "stateCode": "SK",
    "country": "CA"
  },
  "475": {
    "type": "local",
    "city": "Bridgeport",
    "state": "Connecticut",
    "stateCode": "CT",
    "country": "US"
  },
  "478": {
    "type": "local",
    "city": "Macon",
    "state": "Georgia",
    "stateCode": "GA",
    "country": "US"
  },
  "479": {
    "type": "local",
    "city": "Fayetteville",
    "state": "Arkansas",
    "stateCode": "AR",
    "country": "US"
  },
  "480": {
    "type": "local",
    "city": "Chandler",
    "state": "Arizona",
    "stateCode": "AZ",
    "country": "US"
  },
  "484": {
    "type": "local",
    "city": "Allentown",
    "state": "Pennsylvania",
    "stateCode": "PA",
    "country": "US"
  },
  "501": {
    "type": "local",
    "city": "Little Rock",
    "state": "Arkansas",
    "stateCode": "AR",
    "country": "US"
  },
  "502": {
    "type": "local",
    "city": "Louisville",
    "state": "Kentucky",
    "stateCode": "KY",
    "country": "US"
  },
  "503": {
    "type": "local",
    "city": "Beaver",
    "state": "Oregon",
    "stateCode": "OR",
    "country": "US"
  },
  "504": {
    "type": "local",
    "city": "Kenner",
    "state": "Louisiana",
    "stateCode": "LA",
    "country": "US"
  },
  "505": {
    "type": "local",
    "city": "Albuquerque",
    "state": "New Mexico",
    "stateCode": "NM",
    "country": "US"
  },
  "506": {
    "type": "local",
    "city": "Moncton",
    "state": "New Brunswick",
    "stateCode": "NB",
    "country": "CA"
  },
  "507": {
    "type": "local",
    "city": "Austin",
    "state": "Minnesota",
    "stateCode": "MN",
    "country": "US"
  },
  "508": {
    "type": "local",
    "city": "Cambridge",
    "state": "Massachusetts",
    "stateCode": "MA",
    "country": "US"
  },
  "509": {
    "type": "local",
    "city": "Kennewick",
    "state": "Washington",
    "stateCode": "WA",
    "country": "US"
  },
  "510": {
    "type": "local",
    "city": "Alameda",
    "state": "California",
    "stateCode": "CA",
    "country": "US"
  },
  "512": {
    "type": "local",
    "city": "Austin",
    "state": "Texas",
    "stateCode": "TX",
    "country": "US"
  },
  "513": {
    "type": "local",
    "city": "Cincinnati",
    "state": "Ohio",
    "stateCode": "OH",
    "country": "US"
  },
  "514": {
    "type": "local",
    "city": "Montreal",
    "state": "Quebec",
    "stateCode": "QC",
    "country": "CA"
  },
  "515": {
    "type": "local",
    "city": "Ames",
    "state": "Iowa",
    "stateCode": "IA",
    "country": "US"
  },
  "516": {
    "type": "local",
    "city": "Freeport",
    "state": "New York",
    "stateCode": "NY",
    "country": "US"
  },
  "517": {
    "type": "local",
    "city": "Charlotte",
    "state": "Michigan",
    "stateCode": "MI",
    "country": "US"
  },
  "518": {
    "type": "local",
    "city": "Albany",
    "state": "New York",
    "stateCode": "NY",
    "country": "US"
  },
  "519": {
    "type": "local",
    "city": "London",
    "state": "Ontario",
    "stateCode": "ON",
    "country": "CA"
  },
  "520": {
    "type": "local",
    "city": "Casas Adobes",
    "state": "Arizona",
    "stateCode": "AZ",
    "country": "US"
  },
  "530": {
    "type": "local",
    "city": "Chico",
    "state": "California",
    "stateCode": "CA",
    "country": "US"
  },
  "531": {
    "type": "local",
    "city": "Omaha",
    "state": "Nebraska",
    "stateCode": "NE",
    "country": "US"
  },
  "534": {
    "type": "local",
    "city": "Eau Claire",
    "state": "Wisconsin",
    "stateCode": "WI",
    "country": "US"
  },
  "539": {
    "type": "local",
    "stateCode": "OK",
    "state": "Oklahoma",
    "city": "Bartlesville",
    "country": "US"
  },
  "540": {
    "type": "local",
    "city": "Blacksburg",
    "state": "Virginia",
    "stateCode": "VA",
    "country": "US"
  },
  "541": {
    "type": "local",
    "city": "Bend",
    "state": "Oregon",
    "stateCode": "OR",
    "country": "US"
  },
  "548": {
    "type": "local",
    "city": "London",
    "state": "Ontario",
    "stateCode": "ON",
    "country": "CA"
  },
  "551": {
    "type": "local",
    "city": "Bayonne",
    "state": "New Jersey",
    "stateCode": "NJ",
    "country": "US"
  },
  "557": {
    "type": "local",
    "city": "St. Louis",
    "state": "Missouri",
    "stateCode": "MO",
    "country": "US"
  },
  "559": {
    "type": "local",
    "city": "Clovis",
    "state": "California",
    "stateCode": "CA",
    "country": "US"
  },
  "561": {
    "type": "local",
    "city": "Boca Raton",
    "state": "Florida",
    "stateCode": "FL",
    "country": "US"
  },
  "562": {
    "type": "local",
    "city": "Bellflower",
    "state": "California",
    "stateCode": "CA",
    "country": "US"
  },
  "563": {
    "type": "local",
    "city": "Davenport",
    "state": "Iowa",
    "stateCode": "IA",
    "country": "US"
  },
  "564": {
    "type": "local",
    "city": "Seattle",
    "state": "Washington",
    "stateCode": "WA",
    "country": "US"
  },
  "567": {
    "type": "local",
    "city": "Toledo",
    "state": "Ohio",
    "stateCode": "OH",
    "country": "US"
  },
  "570": {
    "type": "local",
    "city": "Scranton",
    "state": "Pennsylvania",
    "stateCode": "PA",
    "country": "US"
  },
  "571": {
    "type": "local",
    "city": "Alexandria",
    "state": "Virginia",
    "stateCode": "VA",
    "country": "US"
  },
  "573": {
    "type": "local",
    "city": "Columbia",
    "state": "Missouri",
    "stateCode": "MO",
    "country": "US"
  },
  "574": {
    "type": "local",
    "city": "Elkhart",
    "state": "Indiana",
    "stateCode": "IN",
    "country": "US"
  },
  "575": {
    "type": "local",
    "city": "Alamogordo",
    "state": "New Mexico",
    "stateCode": "NM",
    "country": "US"
  },
  "579": {
    "type": "local",
    "city": "Granby",
    "state": "Quebec",
    "stateCode": "QC",
    "country": "CA"
  },
  "580": {
    "type": "local",
    "city": "Lawton",
    "state": "Oklahoma",
    "stateCode": "OK",
    "country": "US"
  },
  "581": {
    "type": "local",
    "city": "Quebec",
    "state": "Quebec",
    "stateCode": "QC",
    "country": "CA"
  },
  "584": {
    "type": "local",
    "city": "Winnipeg",
    "state": "Manitoba",
    "stateCode": "MB",
    "country": "CA"
  },
  "585": {
    "type": "local",
    "city": "Arcade",
    "state": "New York",
    "stateCode": "NY",
    "country": "US"
  },
  "586": {
    "type": "local",
    "city": "Sterling Heights",
    "state": "Michigan",
    "stateCode": "MI",
    "country": "US"
  },
  "587": {
    "type": "local",
    "city": "Edmonton",
    "state": "Alberta",
    "stateCode": "AB",
    "country": "CA"
  },
  "601": {
    "type": "local",
    "city": "Hattiesburg",
    "state": "Mississippi",
    "stateCode": "MS",
    "country": "US"
  },
  "602": {
    "type": "local",
    "city": "Phoenix",
    "state": "Arizona",
    "stateCode": "AZ",
    "country": "US"
  },
  "603": {
    "type": "local",
    "city": "Dover",
    "state": "New Hampshire",
    "stateCode": "NH",
    "country": "US"
  },
  "604": {
    "type": "local",
    "city": "Vancouver",
    "state": "British Columbia",
    "stateCode": "BC",
    "country": "CA"
  },
  "605": {
    "type": "local",
    "city": "Rapid City",
    "state": "South Dakota",
    "stateCode": "SD",
    "country": "US"
  },
  "606": {
    "type": "local",
    "city": "Ashland",
    "state": "Kentucky",
    "stateCode": "KY",
    "country": "US"
  },
  "607": {
    "type": "local",
    "city": "Elmira",
    "state": "New York",
    "stateCode": "NY",
    "country": "US"
  },
  "608": {
    "type": "local",
    "city": "Janesville",
    "state": "Wisconsin",
    "stateCode": "WI",
    "country": "US"
  },
  "609": {
    "type": "local",
    "city": "Allentown",
    "state": "New Jersey",
    "stateCode": "NJ",
    "country": "US"
  },
  "610": {
    "type": "local",
    "city": "Allentown",
    "state": "Pennsylvania",
    "stateCode": "PA",
    "country": "US"
  },
  "612": {
    "type": "local",
    "city": "Minneapolis",
    "state": "Minnesota",
    "stateCode": "MN",
    "country": "US"
  },
  "613": {
    "type": "local",
    "city": "Ottawa",
    "state": "Ontario",
    "stateCode": "ON",
    "country": "CA"
  },
  "614": {
    "type": "local",
    "city": "Columbus",
    "state": "Ohio",
    "stateCode": "OH",
    "country": "US"
  },
  "615": {
    "type": "local",
    "city": "Murfreesboro",
    "state": "Tennessee",
    "stateCode": "TN",
    "country": "US"
  },
  "616": {
    "type": "local",
    "city": "Grand Rapids",
    "state": "Michigan",
    "stateCode": "MI",
    "country": "US"
  },
  "617": {
    "type": "local",
    "city": "Boston",
    "state": "Massachusetts",
    "stateCode": "MA",
    "country": "US"
  },
  "618": {
    "type": "local",
    "city": "Alton",
    "state": "Illinois",
    "stateCode": "IL",
    "country": "US"
  },
  "619": {
    "type": "local",
    "city": "Chula Vista",
    "state": "California",
    "stateCode": "CA",
    "country": "US"
  },
  "620": {
    "type": "local",
    "city": "Dodge City",
    "state": "Kansas",
    "stateCode": "KS",
    "country": "US"
  },
  "623": {
    "type": "local",
    "city": "Phoenix",
    "state": "Arizona",
    "stateCode": "AZ",
    "country": "US"
  },
  "626": {
    "type": "local",
    "city": "Alhambra",
    "state": "California",
    "stateCode": "CA",
    "country": "US"
  },
  "627": {
    "type": "local",
    "city": "santa rosa",
    "state": "California",
    "stateCode": "CA",
    "country": "US"
  },
  "628": {
    "type": "local",
    "city": "San Francisco",
    "state": "California",
    "stateCode": "CA",
    "country": "US"
  },
  "629": {
    "type": "local",
    "stateCode": "TN",
    "state": "Tennessee",
    "city": "Brentwood",
    "country": "US"
  },
  "630": {
    "type": "local",
    "city": "Naperville",
    "state": "Illinois",
    "stateCode": "IL",
    "country": "US"
  },
  "631": {
    "type": "local",
    "city": "Babylon",
    "state": "New York",
    "stateCode": "NY",
    "country": "US"
  },
  "636": {
    "type": "local",
    "city": "St. Charles",
    "state": "Missouri",
    "stateCode": "MO",
    "country": "US"
  },
  "639": {
    "type": "local",
    "city": "Saskatoon",
    "state": "Saskatchewan",
    "stateCode": "SK",
    "country": "CA"
  },
  "640": {
    "type": "local",
    "city": "Allentown",
    "state": "New Jersey",
    "stateCode": "NJ",
    "country": "US"
  },
  "641": {
    "type": "local",
    "city": "Mason City",
    "state": "Iowa",
    "stateCode": "IA",
    "country": "US"
  },
  "646": {
    "type": "local",
    "city": "New York City",
    "state": "New York",
    "stateCode": "NY",
    "country": "US"
  },
  "647": {
    "type": "local",
    "city": "Toronto",
    "state": "Ontario",
    "stateCode": "ON",
    "country": "CA"
  },
  "650": {
    "type": "local",
    "city": "Daly City",
    "state": "California",
    "stateCode": "CA",
    "country": "US"
  },
  "651": {
    "type": "local",
    "city": "St. Paul",
    "state": "Minnesota",
    "stateCode": "MN",
    "country": "US"
  },
  "657": {
    "type": "local",
    "city": "Anaheim",
    "state": "California",
    "stateCode": "CA",
    "country": "US"
  },
  "659": {
    "type": "local",
    "city": "Birmingham",
    "state": "Alabama",
    "stateCode": "AL",
    "country": "US"
  },
  "660": {
    "type": "local",
    "city": "Marshall",
    "state": "Missouri",
    "stateCode": "MO",
    "country": "US"
  },
  "661": {
    "type": "local",
    "city": "Earlimart",
    "state": "California",
    "stateCode": "CA",
    "country": "US"
  },
  "662": {
    "type": "local",
    "city": "Starkville",
    "state": "Mississippi",
    "stateCode": "MS",
    "country": "US"
  },
  "667": {
    "type": "local",
    "city": "Baltimore",
    "state": "Maryland",
    "stateCode": "MD",
    "country": "US"
  },
  "669": {
    "type": "local",
    "city": "San Jose",
    "state": "California",
    "stateCode": "CA",
    "country": "US"
  },
  "670": {
    "type": "local",
    "city": "saipan",
    "state": "northern mariana islands",
    "stateCode": "MP",
    "country": "US"
  },
  "671": {
    "type": "local",
    "city": "Hagatna",
    "state": "Guam",
    "stateCode": "GU",
    "country": "US"
  },
  "672": {
    "type": "local",
    "city": "Vancouver",
    "state": "British Columbia",
    "stateCode": "BC",
    "country": "CA"
  },
  "678": {
    "type": "local",
    "city": "Atlanta",
    "state": "Georgia",
    "stateCode": "GA",
    "country": "US"
  },
  "679": {
    "type": "local",
    "city": "Detroit",
    "state": "Michigan",
    "stateCode": "MI",
    "country": "US"
  },
  "680": {
    "type": "local",
    "stateCode": "NY",
    "state": "New York",
    "city": "Auburn",
    "country": "US"
  },
  "681": {
    "type": "local",
    "city": "Charleston",
    "state": "West Virginia",
    "stateCode": "WV",
    "country": "US"
  },
  "682": {
    "type": "local",
    "city": "Arlington",
    "state": "Texas",
    "stateCode": "TX",
    "country": "US"
  },
  "683": {
    "type": "local",
    "city": "Sudbury",
    "state": "Ontario",
    "stateCode": "ON",
    "country": "CA"
  },
  "684": {
    "type": "local",
    "city": "Pago Pago",
    "state": "American Samoa",
    "stateCode": "AS",
    "country": "US"
  },
  "689": {
    "type": "local",
    "city": "Orlando",
    "state": "Florida",
    "stateCode": "FL",
    "country": "US"
  },
  "701": {
    "type": "local",
    "city": "Bismarck",
    "state": "North Dakota",
    "stateCode": "ND",
    "country": "US"
  },
  "702": {
    "type": "local",
    "city": "Henderson",
    "state": "Nevada",
    "stateCode": "NV",
    "country": "US"
  },
  "703": {
    "type": "local",
    "city": "Alexandria",
    "state": "Virginia",
    "stateCode": "VA",
    "country": "US"
  },
  "704": {
    "type": "local",
    "city": "Charlotte",
    "state": "North Carolina",
    "stateCode": "NC",
    "country": "US"
  },
  "705": {
    "type": "local",
    "city": "Sudbury",
    "state": "Ontario",
    "stateCode": "ON",
    "country": "CA"
  },
  "706": {
    "type": "local",
    "city": "Athens",
    "state": "Georgia",
    "stateCode": "GA",
    "country": "US"
  },
  "707": {
    "type": "local",
    "city": "Benicia",
    "state": "California",
    "stateCode": "CA",
    "country": "US"
  },
  "708": {
    "type": "local",
    "city": "Berwyn",
    "state": "Illinois",
    "stateCode": "IL",
    "country": "US"
  },
  "709": {
    "type": "local",
    "city": "St. John's",
    "state": "Newfoundland and Labrador",
    "stateCode": "NL",
    "country": "CA"
  },
  "712": {
    "type": "local",
    "city": "Council Bluffs",
    "state": "Iowa",
    "stateCode": "IA",
    "country": "US"
  },
  "713": {
    "type": "local",
    "city": "Houston",
    "state": "Texas",
    "stateCode": "TX",
    "country": "US"
  },
  "714": {
    "type": "local",
    "city": "Anaheim",
    "state": "California",
    "stateCode": "CA",
    "country": "US"
  },
  "715": {
    "type": "local",
    "city": "Chippewa Falls",
    "state": "Wisconsin",
    "stateCode": "WI",
    "country": "US"
  },
  "716": {
    "type": "local",
    "city": "Cattaraugus",
    "state": "New York",
    "stateCode": "NY",
    "country": "US"
  },
  "717": {
    "type": "local",
    "city": "Lancaster",
    "state": "Pennsylvania",
    "stateCode": "PA",
    "country": "US"
  },
  "718": {
    "type": "local",
    "city": "Bellerose",
    "state": "New York",
    "stateCode": "NY",
    "country": "US"
  },
  "719": {
    "type": "local",
    "city": "Alamosa",
    "state": "Colorado",
    "stateCode": "CO",
    "country": "US"
  },
  "720": {
    "type": "local",
    "city": "Boulder",
    "state": "Colorado",
    "stateCode": "CO",
    "country": "US"
  },
  "724": {
    "type": "local",
    "city": "New Castle",
    "state": "Pennsylvania",
    "stateCode": "PA",
    "country": "US"
  },
  "725": {
    "type": "local",
    "stateCode": "NV",
    "state": "Nevada",
    "city": "Henderson",
    "country": "US"
  },
  "726": {
    "type": "local",
    "stateCode": "TX",
    "state": "Texas",
    "city": "San Antonio",
    "country": "US"
  },
  "727": {
    "type": "local",
    "city": "Clearwater",
    "state": "Florida",
    "stateCode": "FL",
    "country": "US"
  },
  "730": {
    "type": "local",
    "city": "Alton",
    "state": "Illinois",
    "stateCode": "IL",
    "country": "US"
  },
  "731": {
    "type": "local",
    "city": "Jackson",
    "state": "Tennessee",
    "stateCode": "TN",
    "country": "US"
  },
  "732": {
    "type": "local",
    "city": "Brick Township",
    "state": "New Jersey",
    "stateCode": "NJ",
    "country": "US"
  },
  "734": {
    "type": "local",
    "city": "Ann Arbor",
    "state": "Michigan",
    "stateCode": "MI",
    "country": "US"
  },
  "737": {
    "type": "local",
    "city": "Austin",
    "state": "Texas",
    "stateCode": "TX",
    "country": "US"
  },
  "740": {
    "type": "local",
    "city": "Athens",
    "state": "Ohio",
    "stateCode": "OH",
    "country": "US"
  },
  "742": {
    "type": "local",
    "city": "Hamilton",
    "state": "Ontario",
    "stateCode": "ON",
    "country": "CA"
  },
  "743": {
    "type": "local",
    "city": "Greensboro",
    "state": "North Carolina",
    "stateCode": "NC",
    "country": "US"
  },
  "747": {
    "type": "local",
    "city": "Burbank",
    "state": "California",
    "stateCode": "CA",
    "country": "US"
  },
  "753": {
    "type": "local",
    "city": "Ottawa",
    "state": "Ontario",
    "stateCode": "ON",
    "country": "CA"
  },
  "754": {
    "type": "local",
    "city": "Coral Springs",
    "state": "Florida",
    "stateCode": "FL",
    "country": "US"
  },
  "757": {
    "type": "local",
    "city": "Chesapeake",
    "state": "Virginia",
    "stateCode": "VA",
    "country": "US"
  },
  "760": {
    "type": "local",
    "city": "Apple Valley",
    "state": "California",
    "stateCode": "CA",
    "country": "US"
  },
  "762": {
    "type": "local",
    "city": "Athens",
    "state": "Georgia",
    "stateCode": "GA",
    "country": "US"
  },
  "763": {
    "type": "local",
    "city": "Brooklyn Park",
    "state": "Minnesota",
    "stateCode": "MN",
    "country": "US"
  },
  "765": {
    "type": "local",
    "city": "Kokomo",
    "state": "Indiana",
    "stateCode": "IN",
    "country": "US"
  },
  "769": {
    "type": "local",
    "city": "Hattiesburg",
    "state": "Mississippi",
    "stateCode": "MS",
    "country": "US"
  },
  "770": {
    "type": "local",
    "city": "Atlanta",
    "state": "Georgia",
    "stateCode": "GA",
    "country": "US"
  },
  "772": {
    "type": "local",
    "city": "Port St. Lucie",
    "state": "Florida",
    "stateCode": "FL",
    "country": "US"
  },
  "773": {
    "type": "local",
    "city": "Chicago",
    "state": "Illinois",
    "stateCode": "IL",
    "country": "US"
  },
  "774": {
    "type": "local",
    "city": "Brockton",
    "state": "Massachusetts",
    "stateCode": "MA",
    "country": "US"
  },
  "775": {
    "type": "local",
    "city": "Carson City",
    "state": "Nevada",
    "stateCode": "NV",
    "country": "US"
  },
  "778": {
    "type": "local",
    "city": "Vancouver",
    "state": "British Columbia",
    "stateCode": "BC",
    "country": "CA"
  },
  "779": {
    "type": "local",
    "city": "Joliet",
    "state": "Illinois",
    "stateCode": "IL",
    "country": "US"
  },
  "780": {
    "type": "local",
    "city": "Edmonton",
    "state": "Alberta",
    "stateCode": "AB",
    "country": "CA"
  },
  "781": {
    "type": "local",
    "city": "Lynn",
    "state": "Massachusetts",
    "stateCode": "MA",
    "country": "US"
  },
  "782": {
    "type": "local",
    "city": "Halifax",
    "state": "Nova Scotia",
    "stateCode": "NS",
    "country": "CA"
  },
  "785": {
    "type": "local",
    "city": "Abilene",
    "state": "Kansas",
    "stateCode": "KS",
    "country": "US"
  },
  "786": {
    "type": "local",
    "city": "Hialeah",
    "state": "Florida",
    "stateCode": "FL",
    "country": "US"
  },
  "800": {
    "type": "toll-free",
    "city": null,
    "state": null,
    "stateCode": null,
    "country": "US"
  },
  "801": {
    "type": "local",
    "city": "Ogden",
    "state": "Utah",
    "stateCode": "UT",
    "country": "US"
  },
  "802": {
    "type": "local",
    "city": "Bennington",
    "state": "Vermont",
    "stateCode": "VT",
    "country": "US"
  },
  "803": {
    "type": "local",
    "city": "Columbia",
    "state": "South Carolina",
    "stateCode": "SC",
    "country": "US"
  },
  "804": {
    "type": "local",
    "city": "Mechanicsville",
    "state": "Virginia",
    "stateCode": "VA",
    "country": "US"
  },
  "805": {
    "type": "local",
    "city": "Camarillo",
    "state": "California",
    "stateCode": "CA",
    "country": "US"
  },
  "806": {
    "type": "local",
    "city": "Amarillo",
    "state": "Texas",
    "stateCode": "TX",
    "country": "US"
  },
  "807": {
    "type": "local",
    "city": "Kenora",
    "state": "Ontario",
    "stateCode": "ON",
    "country": "CA"
  },
  "808": {
    "type": "local",
    "city": "Honolulu",
    "state": "Hawaii",
    "stateCode": "HI",
    "country": "US"
  },
  "810": {
    "type": "local",
    "city": "Flint",
    "state": "Michigan",
    "stateCode": "MI",
    "country": "US"
  },
  "812": {
    "type": "local",
    "city": "Bloomington",
    "state": "Indiana",
    "stateCode": "IN",
    "country": "US"
  },
  "813": {
    "type": "local",
    "city": "Tampa",
    "state": "Florida",
    "stateCode": "FL",
    "country": "US"
  },
  "814": {
    "type": "local",
    "city": "Erie",
    "state": "Pennsylvania",
    "stateCode": "PA",
    "country": "US"
  },
  "815": {
    "type": "local",
    "city": "Joliet",
    "state": "Illinois",
    "stateCode": "IL",
    "country": "US"
  },
  "816": {
    "type": "local",
    "city": "Kansas City",
    "state": "Missouri",
    "stateCode": "MO",
    "country": "US"
  },
  "817": {
    "type": "local",
    "city": "Arlington",
    "state": "Texas",
    "stateCode": "TX",
    "country": "US"
  },
  "818": {
    "type": "local",
    "city": "Agoura Hills",
    "state": "California",
    "stateCode": "CA",
    "country": "US"
  },
  "819": {
    "type": "local",
    "city": "Sherbrooke",
    "state": "Quebec",
    "stateCode": "QC",
    "country": "CA"
  },
  "820": {
    "type": "local",
    "city": "Camarillo",
    "state": "California",
    "stateCode": "CA",
    "country": "US"
  },
  "822": {
    "type": "toll-free",
    "city": null,
    "state": null,
    "stateCode": null,
    "country": "US"
  },
  "825": {
    "type": "local",
    "city": "Calgary",
    "state": "Alberta",
    "stateCode": "AB",
    "country": "CA"
  },
  "828": {
    "type": "local",
    "city": "Asheville",
    "state": "North Carolina",
    "stateCode": "NC",
    "country": "US"
  },
  "830": {
    "type": "local",
    "city": "Medina",
    "state": "Texas",
    "stateCode": "TX",
    "country": "US"
  },
  "831": {
    "type": "local",
    "city": "Salinas",
    "state": "California",
    "stateCode": "CA",
    "country": "US"
  },
  "832": {
    "type": "local",
    "city": "Baytown",
    "state": "Texas",
    "stateCode": "TX",
    "country": "US"
  },
  "833": {
    "type": "toll-free",
    "city": null,
    "state": null,
    "stateCode": null,
    "country": "US"
  },
  "838": {
    "type": "local",
    "city": "Albany",
    "state": "New York",
    "stateCode": "NY",
    "country": "US"
  },
  "839": {
    "type": "local",
    "city": "Columbia",
    "state": "South Carolina",
    "stateCode": "SC",
    "country": "US"
  },
  "843": {
    "type": "local",
    "city": "Charleston",
    "state": "South Carolina",
    "stateCode": "SC",
    "country": "US"
  },
  "844": {
    "type": "toll-free",
    "city": null,
    "state": null,
    "stateCode": null,
    "country": "US"
  },
  "845": {
    "type": "local",
    "city": "Kingston",
    "state": "New York",
    "stateCode": "NY",
    "country": "US"
  },
  "847": {
    "type": "local",
    "city": "Arlington Heights",
    "state": "Illinois",
    "stateCode": "IL",
    "country": "US"
  },
  "848": {
    "type": "local",
    "city": "Brick Township",
    "state": "New Jersey",
    "stateCode": "NJ",
    "country": "US"
  },
  "850": {
    "type": "local",
    "city": "Pensacola",
    "state": "Florida",
    "stateCode": "FL",
    "country": "US"
  },
  "854": {
    "type": "local",
    "city": "Charleston",
    "state": "South Carolina",
    "stateCode": "SC",
    "country": "US"
  },
  "855": {
    "type": "toll-free",
    "city": null,
    "state": null,
    "stateCode": null,
    "country": "US"
  },
  "856": {
    "type": "local",
    "city": "Camden",
    "state": "New Jersey",
    "stateCode": "NJ",
    "country": "US"
  },
  "857": {
    "type": "local",
    "city": "Boston",
    "state": "Massachusetts",
    "stateCode": "MA",
    "country": "US"
  },
  "858": {
    "type": "local",
    "city": "San Diego",
    "state": "California",
    "stateCode": "CA",
    "country": "US"
  },
  "859": {
    "type": "local",
    "city": "Lexington",
    "state": "Kentucky",
    "stateCode": "KY",
    "country": "US"
  },
  "860": {
    "type": "local",
    "city": "Bristol",
    "state": "Connecticut",
    "stateCode": "CT",
    "country": "US"
  },
  "862": {
    "type": "local",
    "city": "Clifton",
    "state": "New Jersey",
    "stateCode": "NJ",
    "country": "US"
  },
  "863": {
    "type": "local",
    "city": "Lakeland",
    "state": "Florida",
    "stateCode": "FL",
    "country": "US"
  },
  "864": {
    "type": "local",
    "city": "Greenville",
    "state": "South Carolina",
    "stateCode": "SC",
    "country": "US"
  },
  "865": {
    "type": "local",
    "city": "Knoxville",
    "state": "Tennessee",
    "stateCode": "TN",
    "country": "US"
  },
  "866": {
    "type": "toll-free",
    "city": null,
    "state": null,
    "stateCode": null,
    "country": "US"
  },
  "867": {
    "type": "local",
    "city": "Whitehorse",
    "state": "Yukon",
    "stateCode": "YT",
    "country": "CA"
  },
  "870": {
    "type": "local",
    "city": "Jonesboro",
    "state": "Arkansas",
    "stateCode": "AR",
    "country": "US"
  },
  "872": {
    "type": "local",
    "city": "Chicago",
    "state": "Illinois",
    "stateCode": "IL",
    "country": "US"
  },
  "873": {
    "type": "local",
    "city": "Sherbrooke",
    "state": "Quebec",
    "stateCode": "QC",
    "country": "CA"
  },
  "877": {
    "type": "toll-free",
    "city": null,
    "state": null,
    "stateCode": null,
    "country": "US"
  },
  "878": {
    "type": "local",
    "city": "Pittsburgh",
    "state": "Pennsylvania",
    "stateCode": "PA",
    "country": "US"
  },
  "880": {
    "type": "toll-free",
    "city": null,
    "state": null,
    "stateCode": null,
    "country": "US"
  },
  "881": {
    "type": "toll-free",
    "city": null,
    "state": null,
    "stateCode": null,
    "country": "US"
  },
  "882": {
    "type": "toll-free",
    "city": null,
    "state": null,
    "stateCode": null,
    "country": "US"
  },
  "883": {
    "type": "toll-free",
    "city": null,
    "state": null,
    "stateCode": null,
    "country": "US"
  },
  "884": {
    "type": "toll-free",
    "city": null,
    "state": null,
    "stateCode": null,
    "country": "US"
  },
  "885": {
    "type": "toll-free",
    "city": null,
    "state": null,
    "stateCode": null,
    "country": "US"
  },
  "886": {
    "type": "toll-free",
    "city": null,
    "state": null,
    "stateCode": null,
    "country": "US"
  },
  "887": {
    "type": "toll-free",
    "city": null,
    "state": null,
    "stateCode": null,
    "country": "US"
  },
  "888": {
    "type": "toll-free",
    "city": null,
    "state": null,
    "stateCode": null,
    "country": "US"
  },
  "889": {
    "type": "toll-free",
    "city": null,
    "state": null,
    "stateCode": null,
    "country": "US"
  },
  "901": {
    "type": "local",
    "city": "Memphis",
    "state": "Tennessee",
    "stateCode": "TN",
    "country": "US"
  },
  "902": {
    "type": "local",
    "city": "Halifax",
    "state": "Nova Scotia",
    "stateCode": "NS",
    "country": "CA"
  },
  "903": {
    "type": "local",
    "city": "Longview",
    "state": "Texas",
    "stateCode": "TX",
    "country": "US"
  },
  "904": {
    "type": "local",
    "city": "Jacksonville",
    "state": "Florida",
    "stateCode": "FL",
    "country": "US"
  },
  "905": {
    "type": "local",
    "city": "Hamilton",
    "state": "Ontario",
    "stateCode": "ON",
    "country": "CA"
  },
  "906": {
    "type": "local",
    "city": "Sault Ste Marie",
    "state": "Michigan",
    "stateCode": "MI",
    "country": "US"
  },
  "907": {
    "type": "local",
    "city": "Anchorage",
    "state": "Alaska",
    "stateCode": "AK",
    "country": "US"
  },
  "908": {
    "type": "local",
    "city": "Washington Township",
    "state": "New Jersey",
    "stateCode": "NJ",
    "country": "US"
  },
  "909": {
    "type": "local",
    "city": "Anaheim",
    "state": "California",
    "stateCode": "CA",
    "country": "US"
  },
  "910": {
    "type": "local",
    "city": "Fayetteville",
    "state": "North Carolina",
    "stateCode": "NC",
    "country": "US"
  },
  "912": {
    "type": "local",
    "city": "Savannah",
    "state": "Georgia",
    "stateCode": "GA",
    "country": "US"
  },
  "913": {
    "type": "local",
    "city": "Kansas City",
    "state": "Kansas",
    "stateCode": "KS",
    "country": "US"
  },
  "914": {
    "type": "local",
    "city": "Mount Vernon",
    "state": "New York",
    "stateCode": "NY",
    "country": "US"
  },
  "915": {
    "type": "local",
    "city": "El Paso",
    "state": "Texas",
    "stateCode": "TX",
    "country": "US"
  },
  "916": {
    "type": "local",
    "city": "Elk Grove",
    "state": "California",
    "stateCode": "CA",
    "country": "US"
  },
  "917": {
    "type": "local",
    "city": "New York City",
    "state": "New York",
    "stateCode": "NY",
    "country": "US"
  },
  "918": {
    "type": "local",
    "city": "Broken Arrow",
    "state": "Oklahoma",
    "stateCode": "OK",
    "country": "US"
  },
  "919": {
    "type": "local",
    "city": "Cary",
    "state": "North Carolina",
    "stateCode": "NC",
    "country": "US"
  },
  "920": {
    "type": "local",
    "city": "Appleton",
    "state": "Wisconsin",
    "stateCode": "WI",
    "country": "US"
  },
  "925": {
    "type": "local",
    "city": "Antioch",
    "state": "California",
    "stateCode": "CA",
    "country": "US"
  },
  "928": {
    "type": "local",
    "city": "Flagstaff",
    "state": "Arizona",
    "stateCode": "AZ",
    "country": "US"
  },
  "929": {
    "type": "local",
    "city": "Bellerose",
    "state": "New York",
    "stateCode": "NY",
    "country": "US"
  },
  "930": {
    "type": "local",
    "city": "Bloomington",
    "state": "Indiana",
    "stateCode": "IN",
    "country": "US"
  },
  "931": {
    "type": "local",
    "city": "Clarksville",
    "state": "Tennessee",
    "stateCode": "TN",
    "country": "US"
  },
  "934": {
    "type": "local",
    "city": "Babylon",
    "state": "New York",
    "stateCode": "NY",
    "country": "US"
  },
  "936": {
    "type": "local",
    "city": "Huntsville",
    "state": "Texas",
    "stateCode": "TX",
    "country": "US"
  },
  "937": {
    "type": "local",
    "city": "Dayton",
    "state": "Ohio",
    "stateCode": "OH",
    "country": "US"
  },
  "938": {
    "type": "local",
    "city": "Huntsville",
    "state": "Alabama",
    "stateCode": "AL",
    "country": "US"
  },
  "940": {
    "type": "local",
    "city": "Denton",
    "state": "Texas",
    "stateCode": "TX",
    "country": "US"
  },
  "941": {
    "type": "local",
    "city": "Sarasota",
    "state": "Florida",
    "stateCode": "FL",
    "country": "US"
  },
  "947": {
    "type": "local",
    "city": "Farmington Hills",
    "state": "Michigan",
    "stateCode": "MI",
    "country": "US"
  },
  "949": {
    "type": "local",
    "city": "Costa Mesa",
    "state": "California",
    "stateCode": "CA",
    "country": "US"
  },
  "951": {
    "type": "local",
    "city": "Corona",
    "state": "California",
    "stateCode": "CA",
    "country": "US"
  },
  "952": {
    "type": "local",
    "city": "Bloomington",
    "state": "Minnesota",
    "stateCode": "MN",
    "country": "US"
  },
  "954": {
    "type": "local",
    "city": "Fort Lauderdale",
    "state": "Florida",
    "stateCode": "FL",
    "country": "US"
  },
  "956": {
    "type": "local",
    "city": "Laredo",
    "state": "Texas",
    "stateCode": "TX",
    "country": "US"
  },
  "959": {
    "type": "local",
    "city": "Hartford",
    "state": "Connecticut",
    "stateCode": "CT",
    "country": "US"
  },
  "970": {
    "type": "local",
    "city": "Durango",
    "state": "Colorado",
    "stateCode": "CO",
    "country": "US"
  },
  "971": {
    "type": "local",
    "city": "Beaverton",
    "state": "Oregon",
    "stateCode": "OR",
    "country": "US"
  },
  "972": {
    "type": "local",
    "city": "Carrollton",
    "state": "Texas",
    "stateCode": "TX",
    "country": "US"
  },
  "973": {
    "type": "local",
    "city": "Newark",
    "state": "New Jersey",
    "stateCode": "NJ",
    "country": "US"
  },
  "975": {
    "type": "local",
    "city": "Kansas City",
    "state": "Missouri",
    "stateCode": "MO",
    "country": "US"
  },
  "978": {
    "type": "local",
    "city": "Haverhill",
    "state": "Massachusetts",
    "stateCode": "MA",
    "country": "US"
  },
  "979": {
    "type": "local",
    "city": "Bryan",
    "state": "Texas",
    "stateCode": "TX",
    "country": "US"
  },
  "980": {
    "type": "local",
    "city": "Charlotte",
    "state": "North Carolina",
    "stateCode": "NC",
    "country": "US"
  },
  "984": {
    "type": "local",
    "city": "Raleigh",
    "state": "North Carolina",
    "stateCode": "NC",
    "country": "US"
  },
  "985": {
    "type": "local",
    "city": "Hammond",
    "state": "Louisiana",
    "stateCode": "LA",
    "country": "US"
  },
  "986": {
    "type": "local",
    "city": "Boise",
    "state": "Idaho",
    "stateCode": "ID",
    "country": "US"
  },
  "989": {
    "type": "local",
    "city": "Alma",
    "state": "Michigan",
    "stateCode": "MI",
    "country": "US"
  }
}

export const COUNTRY_NAMES = {
  "AF": "Afghanistan",
  "AX": "Åland Islands",
  "AL": "Albania",
  "DZ": "Algeria",
  "AS": "American Samoa",
  "AD": "Andorra",
  "AO": "Angola",
  "AI": "Anguilla",
  "AQ": "Antarctica",
  "AG": "Antigua and Barbuda",
  "AR": "Argentina",
  "AM": "Armenia",
  "AW": "Aruba",
  "AU": "Australia",
  "AT": "Austria",
  "AZ": "Azerbaijan",
  "BS": "Bahamas",
  "BH": "Bahrain",
  "BD": "Bangladesh",
  "BB": "Barbados",
  "BY": "Belarus",
  "BE": "Belgium",
  "BZ": "Belize",
  "BJ": "Benin",
  "BM": "Bermuda",
  "BT": "Bhutan",
  "BO": "Bolivia",
  "BQ": "Caribbean Netherlands",
  "BA": "Bosnia and Herzegovina",
  "BW": "Botswana",
  "BV": "Bouvet Island",
  "BR": "Brazil",
  "IO": "British Indian Ocean Territory",
  "BN": "Brunei",
  "BG": "Bulgaria",
  "BF": "Burkina Faso",
  "BI": "Burundi",
  "CV": "Cape Verde",
  "KH": "Cambodia",
  "CM": "Cameroon",
  "CA": "Canada",
  "KY": "Cayman Islands",
  "CF": "Central African Republic",
  "TD": "Chad",
  "CL": "Chile",
  "CN": "China",
  "CX": "Christmas Island",
  "CC": "Cocos Islands",
  "CO": "Colombia",
  "KM": "Comoros",
  "CG": "Congo",
  "CD": "DR Congo",
  "CK": "Cook Islands",
  "CR": "Costa Rica",
  "CI": "Côte d'Ivoire",
  "HR": "Croatia",
  "CU": "Cuba",
  "CW": "Curaçao",
  "CY": "Cyprus",
  "CZ": "Czech Republic",
  "DK": "Denmark",
  "DJ": "Djibouti",
  "DM": "Dominica",
  "DO": "Dominican Republic",
  "EC": "Ecuador",
  "EG": "Egypt",
  "SV": "El Salvador",
  "GQ": "Equatorial Guinea",
  "ER": "Eritrea",
  "EE": "Estonia",
  "SZ": "Eswatini",
  "ET": "Ethiopia",
  "FK": "Falkland Islands",
  "FO": "Faroe Islands",
  "FJ": "Fiji",
  "FI": "Finland",
  "FR": "France",
  "GF": "French Guiana",
  "PF": "French Polynesia",
  "TF": "French Southern Territories",
  "GA": "Gabon",
  "GM": "Gambia",
  "GE": "Georgia",
  "DE": "Germany",
  "GH": "Ghana",
  "GI": "Gibraltar",
  "GR": "Greece",
  "GL": "Greenland",
  "GD": "Grenada",
  "GP": "Guadeloupe",
  "GU": "Guam",
  "GT": "Guatemala",
  "GG": "Guernsey",
  "GN": "Guinea",
  "GW": "Guinea-Bissau",
  "GY": "Guyana",
  "HT": "Haiti",
  "HM": "Heard and McDonald Islands",
  "VA": "Vatican City",
  "HN": "Honduras",
  "HK": "Hong Kong",
  "HU": "Hungary",
  "IS": "Iceland",
  "IN": "India",
  "ID": "Indonesia",
  "IR": "Iran",
  "IQ": "Iraq",
  "IE": "Ireland",
  "IM": "Isle of Man",
  "IL": "Israel",
  "IT": "Italy",
  "JM": "Jamaica",
  "JP": "Japan",
  "JE": "Jersey",
  "JO": "Jordan",
  "KZ": "Kazakhstan",
  "KE": "Kenya",
  "KI": "Kiribati",
  "KP": "North Korea",
  "KR": "South Korea",
  "KW": "Kuwait",
  "KG": "Kyrgyzstan",
  "LA": "Laos",
  "LV": "Latvia",
  "LB": "Lebanon",
  "LS": "Lesotho",
  "LR": "Liberia",
  "LY": "Libya",
  "LI": "Liechtenstein",
  "LT": "Lithuania",
  "LU": "Luxembourg",
  "MO": "Macau",
  "MG": "Madagascar",
  "MW": "Malawi",
  "MY": "Malaysia",
  "MV": "Maldives",
  "ML": "Mali",
  "MT": "Malta",
  "MH": "Marshall Islands",
  "MQ": "Martinique",
  "MR": "Mauritania",
  "MU": "Mauritius",
  "YT": "Mayotte",
  "MX": "Mexico",
  "FM": "Micronesia",
  "MD": "Moldova",
  "MC": "Monaco",
  "MN": "Mongolia",
  "ME": "Montenegro",
  "MS": "Montserrat",
  "MA": "Morocco",
  "MZ": "Mozambique",
  "MM": "Myanmar",
  "NA": "Namibia",
  "NR": "Nauru",
  "NP": "Nepal",
  "NL": "Netherlands",
  "NC": "New Caledonia",
  "NZ": "New Zealand",
  "NI": "Nicaragua",
  "NE": "Niger",
  "NG": "Nigeria",
  "NU": "Niue",
  "NF": "Norfolk Island",
  "MK": "North Macedonia",
  "MP": "Northern Mariana Islands",
  "NO": "Norway",
  "OM": "Oman",
  "PK": "Pakistan",
  "PW": "Palau",
  "PS": "Palestine",
  "PA": "Panama",
  "PG": "Papua New Guinea",
  "PY": "Paraguay",
  "PE": "Peru",
  "PH": "Philippines",
  "PN": "Pitcairn Islands",
  "PL": "Poland",
  "PT": "Portugal",
  "PR": "Puerto Rico",
  "QA": "Qatar",
  "RE": "Réunion",
  "RO": "Romania",
  "RU": "Russia",
  "RW": "Rwanda",
  "BL": "Saint Barthélemy",
  "SH": "Saint Helena",
  "KN": "Saint Kitts and Nevis",
  "LC": "Saint Lucia",
  "MF": "Saint Martin",
  "PM": "Saint Pierre and Miquelon",
  "VC": "Saint Vincent and the Grenadines",
  "WS": "Samoa",
  "SM": "San Marino",
  "ST": "São Tomé and Príncipe",
  "SA": "Saudi Arabia",
  "SN": "Senegal",
  "RS": "Serbia",
  "SC": "Seychelles",
  "SL": "Sierra Leone",
  "SG": "Singapore",
  "SX": "Sint Maarten",
  "SK": "Slovakia",
  "SI": "Slovenia",
  "SB": "Solomon Islands",
  "SO": "Somalia",
  "ZA": "South Africa",
  "GS": "South Georgia and the South Sandwich Islands",
  "SS": "South Sudan",
  "ES": "Spain",
  "LK": "Sri Lanka",
  "SD": "Sudan",
  "SR": "Suriname",
  "SJ": "Svalbard and Jan Mayen",
  "SE": "Sweden",
  "CH": "Switzerland",
  "SY": "Syria",
  "TW": "Taiwan",
  "TJ": "Tajikistan",
  "TZ": "Tanzania",
  "TH": "Thailand",
  "TL": "Timor-Leste",
  "TG": "Togo",
  "TK": "Tokelau",
  "TO": "Tonga",
  "TT": "Trinidad and Tobago",
  "TN": "Tunisia",
  "TR": "Türkiye",
  "TM": "Turkmenistan",
  "TC": "Turks and Caicos Islands",
  "TV": "Tuvalu",
  "UG": "Uganda",
  "UA": "Ukraine",
  "AE": "United Arab Emirates",
  "GB": "United Kingdom",
  "US": "United States",
  "UM": "U.S. Outlying Islands",
  "UY": "Uruguay",
  "UZ": "Uzbekistan",
  "VU": "Vanuatu",
  "VE": "Venezuela",
  "VN": "Vietnam",
  "VG": "British Virgin Islands",
  "VI": "U.S. Virgin Islands",
  "WF": "Wallis and Futuna",
  "EH": "Western Sahara",
  "YE": "Yemen",
  "ZM": "Zambia",
  "ZW": "Zimbabwe"
};

export const COUNTRY_PHONE_CODES = { "BD": "880", "BE": "32", "BF": "226", "BG": "359", "BA": "387", "BB": "+1-246", "WF": "681", "BL": "590", "BM": "+1-441", "BN": "673", "BO": "591", "BH": "973", "BI": "257", "BJ": "229", "BT": "975", "JM": "+1-876", "BV": "", "BW": "267", "WS": "685", "BQ": "599", "BR": "55", "BS": "+1-242", "JE": "+44-1534", "BY": "375", "BZ": "501", "RU": "7", "RW": "250", "RS": "381", "TL": "670", "RE": "262", "TM": "993", "TJ": "992", "RO": "40", "TK": "690", "GW": "245", "GU": "+1-671", "GT": "502", "GS": "", "GR": "30", "GQ": "240", "GP": "590", "JP": "81", "GY": "592", "GG": "+44-1481", "GF": "594", "GE": "995", "GD": "+1-473", "GB": "44", "GA": "241", "SV": "503", "GN": "224", "GM": "220", "GL": "299", "GI": "350", "GH": "233", "OM": "968", "TN": "216", "JO": "962", "HR": "385", "HT": "509", "HU": "36", "HK": "852", "HN": "504", "HM": " ", "VE": "58", "PR": "+1-787 and 1-939", "PS": "970", "PW": "680", "PT": "351", "SJ": "47", "PY": "595", "IQ": "964", "PA": "507", "PF": "689", "PG": "675", "PE": "51", "PK": "92", "PH": "63", "PN": "870", "PL": "48", "PM": "508", "ZM": "260", "EH": "212", "EE": "372", "EG": "20", "ZA": "27", "EC": "593", "IT": "39", "VN": "84", "SB": "677", "ET": "251", "SO": "252", "ZW": "263", "SA": "966", "ES": "34", "ER": "291", "ME": "382", "MD": "373", "MG": "261", "MF": "590", "MA": "212", "MC": "377", "UZ": "998", "MM": "95", "ML": "223", "MO": "853", "MN": "976", "MH": "692", "MK": "389", "MU": "230", "MT": "356", "MW": "265", "MV": "960", "MQ": "596", "MP": "+1-670", "MS": "+1-664", "MR": "222", "IM": "+44-1624", "UG": "256", "TZ": "255", "MY": "60", "MX": "52", "IL": "972", "FR": "33", "IO": "246", "SH": "290", "FI": "358", "FJ": "679", "FK": "500", "FM": "691", "FO": "298", "NI": "505", "NL": "31", "NO": "47", "NA": "264", "VU": "678", "NC": "687", "NE": "227", "NF": "672", "NG": "234", "NZ": "64", "NP": "977", "NR": "674", "NU": "683", "CK": "682", "XK": "", "CI": "225", "CH": "41", "CO": "57", "CN": "86", "CM": "237", "CL": "56", "CC": "61", "CA": "1", "CG": "242", "CF": "236", "CD": "243", "CZ": "420", "CY": "357", "CX": "61", "CR": "506", "CW": "599", "CV": "238", "CU": "53", "SZ": "268", "SY": "963", "SX": "599", "KG": "996", "KE": "254", "SS": "211", "SR": "597", "KI": "686", "KH": "855", "KN": "+1-869", "KM": "269", "ST": "239", "SK": "421", "KR": "82", "SI": "386", "KP": "850", "KW": "965", "SN": "221", "SM": "378", "SL": "232", "SC": "248", "KZ": "7", "KY": "+1-345", "SG": "65", "SE": "46", "SD": "249", "DO": "+1-809 and 1-829", "DM": "+1-767", "DJ": "253", "DK": "45", "VG": "+1-284", "DE": "49", "YE": "967", "DZ": "213", "US": "1", "UY": "598", "YT": "262", "UM": "+1-8", "LB": "961", "LC": "+1-758", "LA": "856", "TV": "688", "TW": "886", "TT": "+1-868", "TR": "90", "LK": "94", "LI": "423", "LV": "371", "TO": "676", "LT": "370", "LU": "352", "LR": "231", "LS": "266", "TH": "66", "TF": "", "TG": "228", "TD": "235", "TC": "+1-649", "LY": "218", "VA": "379", "VC": "+1-784", "AE": "971", "AD": "376", "AG": "+1-268", "AF": "93", "AI": "+1-264", "VI": "+1-340", "IS": "354", "IR": "98", "AM": "374", "AL": "355", "AO": "244", "AQ": "", "AS": "+1-684", "AR": "54", "AU": "61", "AT": "43", "AW": "297", "IN": "91", "AX": "+358-18", "AZ": "994", "IE": "353", "ID": "62", "UA": "380", "QA": "974", "MZ": "258" };

export const COUNTRY_PHONE_TO_TIMEZONE = {
  "+20": "Africa/Cairo",
  "+211": "Africa/Juba",
  "+212": "Africa/Casablanca",
  "+213": "Africa/Algiers",
  "+216": "Africa/Tunis",
  "+218": "Africa/Tripoli",
  "+220": "Africa/Banjul",
  "+221": "Africa/Dakar",
  "+222": "Africa/Nouakchott",
  "+223": "Africa/Bamako",
  "+224": "Africa/Conakry",
  "+225": "Africa/Abidjan",
  "+226": "Africa/Ouagadougou",
  "+227": "Africa/Niamey",
  "+228": "Africa/Lome",
  "+229": "Africa/Porto-Novo",
  "+230": "Indian/Mauritius",
  "+231": "Africa/Monrovia",
  "+232": "Africa/Freetown",
  "+233": "Africa/Accra",
  "+234": "Africa/Lagos",
  "+235": "Africa/Ndjamena",
  "+236": "Africa/Bangui",
  "+237": "Africa/Douala",
  "+238": "Atlantic/Cape_Verde",
  "+239": "Africa/Sao_Tome",
  "+240": "Africa/Malabo",
  "+241": "Africa/Libreville",
  "+242": "Africa/Brazzaville",
  "+243": "Africa/Kinshasa",
  "+244": "Africa/Luanda",
  "+245": "Africa/Bissau",
  "+246": "Indian/Chagos",
  "+247": "Europe/London",
  "+248": "Indian/Mahe",
  "+249": "Africa/Khartoum",
  "+250": "Africa/Kigali",
  "+251": "Africa/Addis_Ababa",
  "+252": "Africa/Mogadishu",
  "+253": "Africa/Djibouti",
  "+254": "Africa/Nairobi",
  "+255": "Africa/Dar_es_Salaam",
  "+256": "Africa/Kampala",
  "+257": "Africa/Bujumbura",
  "+258": "Africa/Maputo",
  "+260": "Africa/Lusaka",
  "+261": "Indian/Antananarivo",
  "+262": "Indian/Reunion",
  "+263": "Africa/Harare",
  "+264": "Africa/Windhoek",
  "+265": "Africa/Blantyre",
  "+266": "Africa/Maseru",
  "+267": "Africa/Gaborone",
  "+268": "Africa/Mbabane",
  "+269": "Indian/Comoro",
  "+27": "Africa/Johannesburg",
  "+290": "Atlantic/St_Helena",
  "+291": "Africa/Asmara",
  "+297": "America/Aruba",
  "+298": "Atlantic/Faroe",
  "+299": "America/Godthab",
  "+30": "Europe/Athens",
  "+31": "Europe/Amsterdam",
  "+32": "Europe/Brussels",
  "+33": "Europe/Paris",
  "+34": "Europe/Madrid",
  "+350": "Europe/Gibraltar",
  "+351": "Europe/Lisbon",
  "+352": "Europe/Luxembourg",
  "+353": "Europe/Dublin",
  "+354": "Atlantic/Reykjavik",
  "+355": "Europe/Tirane",
  "+356": "Europe/Malta",
  "+357": "Asia/Nicosia",
  "+358": "Europe/Helsinki",
  "+359": "Europe/Sofia",
  "+36": "Europe/Budapest",
  "+370": "Europe/Vilnius",
  "+371": "Europe/Riga",
  "+372": "Europe/Tallinn",
  "+373": "Europe/Chisinau",
  "+374": "Asia/Yerevan",
  "+375": "Europe/Minsk",
  "+376": "Europe/Andorra",
  "+377": "Europe/Monaco",
  "+378": "Europe/San_Marino",
  "+379": "Europe/Vatican",
  "+380": "Europe/Kiev",
  "+381": "Europe/Belgrade",
  "+382": "Europe/Podgorica",
  "+385": "Europe/Zagreb",
  "+386": "Europe/Ljubljana",
  "+387": "Europe/Sarajevo",
  "+388": "Europe/London",
  "+389": "Europe/Skopje",
  "+39": "Europe/Rome",
  "+40": "Europe/Bucharest",
  "+41": "Europe/Zurich",
  "+420": "Europe/Prague",
  "+421": "Europe/Bratislava",
  "+423": "Europe/Vaduz",
  "+43": "Europe/Vienna",
  "+44": "Europe/London",
  "+45": "Europe/Copenhagen",
  "+46": "Europe/Stockholm",
  "+47": "Europe/Oslo",
  "+48": "Europe/Warsaw",
  "+49": "Europe/Berlin",
  "+500": "Atlantic/Stanley",
  "+501": "America/Belize",
  "+502": "America/Guatemala",
  "+503": "America/El_Salvador",
  "+504": "America/Tegucigalpa",
  "+505": "America/Managua",
  "+506": "America/Costa_Rica",
  "+507": "America/Panama",
  "+508": "America/Miquelon",
  "+509": "America/Port-au-Prince",
  "+51": "America/Lima",
  "+52": "America/Mexico_City",
  "+53": "America/Havana",
  "+54": "America/Argentina/Buenos_Aires",
  "+55": "America/Noronha",
  "+56": "America/Santiago",
  "+57": "America/Bogota",
  "+58": "America/Caracas",
  "+590": "America/Guadeloupe",
  "+591": "America/La_Paz",
  "+592": "America/Guyana",
  "+593": "America/Guayaquil",
  "+594": "America/Cayenne",
  "+595": "America/Asuncion",
  "+596": "America/Martinique",
  "+597": "America/Paramaribo",
  "+598": "America/Montevideo",
  "+599": "America/Kralendijk",
  "+60": "Asia/Kuala_Lumpur",
  "+61": "Australia/Lord_Howe",
  "+62": "Asia/Jakarta",
  "+63": "Asia/Manila",
  "+64": "Pacific/Auckland",
  "+65": "Asia/Singapore",
  "+66": "Asia/Bangkok",
  "+670": "Asia/Dili",
  "+672": "Pacific/Norfolk",
  "+673": "Asia/Brunei",
  "+674": "Pacific/Nauru",
  "+675": "Pacific/Port_Moresby",
  "+676": "Pacific/Tongatapu",
  "+677": "Pacific/Guadalcanal",
  "+678": "Pacific/Efate",
  "+679": "Pacific/Fiji",
  "+680": "Pacific/Palau",
  "+681": "Pacific/Wallis",
  "+682": "Pacific/Rarotonga",
  "+683": "Pacific/Niue",
  "+685": "Pacific/Apia",
  "+686": "Pacific/Tarawa",
  "+687": "Pacific/Noumea",
  "+688": "Pacific/Funafuti",
  "+689": "Pacific/Tahiti",
  "+690": "Pacific/Fakaofo",
  "+691": "Pacific/Chuuk",
  "+692": "Pacific/Majuro",
  "+73": "Europe/Kaliningrad",
  "+74": "Europe/Kaliningrad",
  "+76": "Asia/Almaty",
  "+77": "Asia/Almaty",
  "+78": "Europe/Kaliningrad",
  "+7940": "Europe/Kaliningrad",
  "+81": "Asia/Tokyo",
  "+82": "Asia/Seoul",
  "+84": "Asia/Ho_Chi_Minh",
  "+850": "Asia/Pyongyang",
  "+852": "Asia/Hong_Kong",
  "+853": "Asia/Macau",
  "+855": "Asia/Phnom_Penh",
  "+856": "Asia/Vientiane",
  "+86": "Asia/Shanghai",
  "+880": "Asia/Dhaka",
  "+886": "Asia/Taipei",
  "+90": "Europe/Istanbul",
  "+91": "Asia/Kolkata",
  "+92": "Asia/Karachi",
  "+93": "Asia/Kabul",
  "+94": "Asia/Colombo",
  "+95": "Asia/Rangoon",
  "+960": "Indian/Maldives",
  "+961": "Asia/Beirut",
  "+962": "Asia/Amman",
  "+963": "Asia/Damascus",
  "+964": "Asia/Baghdad",
  "+965": "Asia/Kuwait",
  "+966": "Asia/Riyadh",
  "+967": "Asia/Aden",
  "+968": "Asia/Muscat",
  "+970": "Asia/Gaza",
  "+971": "Asia/Dubai",
  "+972": "Asia/Jerusalem",
  "+973": "Asia/Bahrain",
  "+974": "Asia/Qatar",
  "+975": "Asia/Thimphu",
  "+976": "Asia/Ulaanbaatar",
  "+977": "Asia/Kathmandu",
  "+98": "Asia/Tehran",
  "+992": "Asia/Dushanbe",
  "+993": "Asia/Ashgabat",
  "+994": "Asia/Baku",
  "+995": "Asia/Tbilisi",
  "+996": "Asia/Bishkek",
  "+998": "Asia/Samarkand",
  "201": "America/New_York",
  "202": "America/New_York",
  "203": "America/New_York",
  "204": "America/Chicago",
  "205": "America/Chicago",
  "206": "America/Los_Angeles",
  "207": "America/New_York",
  "208": "America/Denver",
  "209": "America/Los_Angeles",
  "210": "America/Chicago",
  "212": "America/New_York",
  "213": "America/Los_Angeles",
  "214": "America/Chicago",
  "215": "America/New_York",
  "216": "America/New_York",
  "217": "America/Chicago",
  "218": "America/Chicago",
  "219": "America/Indiana/Indianapolis",
  "224": "America/Chicago",
  "225": "America/Chicago",
  "226": "America/New_York",
  "228": "America/Chicago",
  "229": "America/New_York",
  "231": "America/Detroit",
  "234": "America/New_York",
  "236": "America/New_York",
  "239": "America/New_York",
  "240": "America/New_York",
  "242": "America/Nassau",
  "246": "America/Barbados",
  "248": "America/Detroit",
  "250": "America/Los_Angeles",
  "251": "America/Chicago",
  "252": "America/New_York",
  "253": "America/Los_Angeles",
  "254": "America/Chicago",
  "256": "America/Chicago",
  "260": "America/Indiana/Indianapolis",
  "262": "America/Chicago",
  "264": "America/Anguilla",
  "267": "America/New_York",
  "268": "America/Antigua",
  "269": "America/Detroit",
  "270": "America/Chicago",
  "276": "America/New_York",
  "278": "America/New_York",
  "281": "America/Chicago",
  "283": "America/New_York",
  "284": "America/Tortola",
  "289": "America/New_York",
  "301": "America/New_York",
  "302": "America/New_York",
  "303": "America/Denver",
  "304": "America/New_York",
  "305": "America/New_York",
  "306": "America/Denver",
  "307": "America/Denver",
  "308": "America/Denver",
  "309": "America/Chicago",
  "310": "America/Los_Angeles",
  "312": "America/Chicago",
  "313": "America/Detroit",
  "314": "America/Chicago",
  "315": "America/New_York",
  "316": "America/Chicago",
  "317": "America/Indiana/Indianapolis",
  "318": "America/Chicago",
  "319": "America/Chicago",
  "320": "America/Chicago",
  "321": "America/New_York",
  "323": "America/Los_Angeles",
  "325": "America/Chicago",
  "330": "America/New_York",
  "331": "America/Chicago",
  "334": "America/Chicago",
  "336": "America/New_York",
  "337": "America/Chicago",
  "339": "America/New_York",
  "340": "America/St_Thomas",
  "345": "America/Cayman",
  "347": "America/New_York",
  "351": "America/New_York",
  "352": "America/New_York",
  "360": "America/Los_Angeles",
  "361": "America/Chicago",
  "369": "America/Los_Angeles",
  "380": "America/New_York",
  "385": "America/Denver",
  "386": "America/New_York",
  "401": "America/New_York",
  "402": "America/Chicago",
  "403": "America/Denver",
  "404": "America/New_York",
  "405": "America/Chicago",
  "406": "America/Denver",
  "407": "America/New_York",
  "408": "America/Los_Angeles",
  "409": "America/Chicago",
  "410": "America/New_York",
  "412": "America/New_York",
  "413": "America/New_York",
  "414": "America/Chicago",
  "415": "America/Los_Angeles",
  "416": "America/New_York",
  "417": "America/Chicago",
  "418": "America/New_York",
  "419": "America/New_York",
  "423": "America/New_York",
  "424": "America/Los_Angeles",
  "425": "America/Los_Angeles",
  "430": "America/Chicago",
  "432": "America/Chicago",
  "434": "America/New_York",
  "435": "America/Denver",
  "438": "America/Denver",
  "440": "America/New_York",
  "441": "Atlantic/Bermuda",
  "442": "America/Los_Angeles",
  "443": "America/New_York",
  "450": "America/New_York",
  "464": "America/Chicago",
  "469": "America/Chicago",
  "470": "America/New_York",
  "473": "America/Grenada",
  "475": "America/New_York",
  "478": "America/New_York",
  "479": "America/Chicago",
  "480": "America/Phoenix",
  "484": "America/New_York",
  "501": "America/Chicago",
  "502": "America/Kentucky/Louisville",
  "503": "America/Los_Angeles",
  "504": "America/Chicago",
  "505": "America/Denver",
  "506": "America/New_York",
  "507": "America/Chicago",
  "508": "America/New_York",
  "509": "America/Los_Angeles",
  "510": "America/Los_Angeles",
  "512": "America/Chicago",
  "513": "America/New_York",
  "514": "America/New_York",
  "515": "America/Chicago",
  "516": "America/New_York",
  "517": "America/Detroit",
  "518": "America/New_York",
  "519": "America/New_York",
  "520": "America/Phoenix",
  "530": "America/Los_Angeles",
  "540": "America/New_York",
  "541": "America/Los_Angeles",
  "551": "America/New_York",
  "557": "America/Chicago",
  "559": "America/Los_Angeles",
  "561": "America/New_York",
  "562": "America/Los_Angeles",
  "563": "America/Chicago",
  "564": "America/Los_Angeles",
  "570": "America/New_York",
  "571": "America/New_York",
  "573": "America/Chicago",
  "574": "America/Indiana/Indianapolis",
  "575": "America/Denver",
  "580": "America/Chicago",
  "585": "America/New_York",
  "586": "America/Detroit",
  "601": "America/Chicago",
  "602": "America/Phoenix",
  "603": "America/New_York",
  "604": "America/Los_Angeles",
  "605": "America/Chicago",
  "606": "America/Kentucky/Louisville",
  "607": "America/New_York",
  "608": "America/Chicago",
  "609": "America/New_York",
  "610": "America/New_York",
  "612": "America/Chicago",
  "613": "America/New_York",
  "614": "America/New_York",
  "615": "America/Chicago",
  "616": "America/New_York",
  "617": "America/New_York",
  "618": "America/Chicago",
  "619": "America/Los_Angeles",
  "620": "America/Chicago",
  "623": "America/Phoenix",
  "626": "America/Los_Angeles",
  "627": "America/Los_Angeles",
  "628": "America/Los_Angeles",
  "630": "America/Chicago",
  "631": "America/New_York",
  "635": "America/New_York",
  "636": "America/Chicago",
  "641": "America/Chicago",
  "646": "America/New_York",
  "647": "America/New_York",
  "649": "America/Grand_Turk",
  "650": "America/Los_Angeles",
  "651": "America/Chicago",
  "660": "America/Chicago",
  "661": "America/Los_Angeles",
  "662": "America/Chicago",
  "664": "America/Montserrat",
  "669": "America/Los_Angeles",
  "670": "Pacific/Saipan",
  "671": "Pacific/Guam",
  "678": "America/New_York",
  "679": "America/New_York",
  "682": "America/Chicago",
  "684": "Pacific/Pago_Pago",
  "689": "America/New_York",
  "701": "America/Chicago",
  "702": "America/Los_Angeles",
  "703": "America/New_York",
  "704": "America/New_York",
  "705": "America/New_York",
  "706": "America/New_York",
  "707": "America/Los_Angeles",
  "708": "America/Chicago",
  "709": "America/New_York",
  "712": "America/Chicago",
  "713": "America/Chicago",
  "714": "America/Los_Angeles",
  "715": "America/Chicago",
  "716": "America/New_York",
  "717": "America/New_York",
  "718": "America/New_York",
  "719": "America/Denver",
  "720": "America/Denver",
  "721": "America/Lower_Princes",
  "724": "America/New_York",
  "727": "America/New_York",
  "731": "America/Chicago",
  "732": "America/New_York",
  "734": "America/Detroit",
  "737": "America/Chicago",
  "740": "America/New_York",
  "747": "America/Los_Angeles",
  "754": "America/New_York",
  "757": "America/New_York",
  "758": "America/St_Lucia",
  "760": "America/Los_Angeles",
  "762": "America/New_York",
  "763": "America/Chicago",
  "764": "America/Los_Angeles",
  "765": "America/New_York",
  "767": "America/Dominica",
  "769": "America/Chicago",
  "770": "America/New_York",
  "772": "America/New_York",
  "773": "America/Chicago",
  "774": "America/New_York",
  "775": "America/Los_Angeles",
  "778": "America/Los_Angeles",
  "779": "America/Chicago",
  "780": "America/Denver",
  "781": "America/New_York",
  "784": "America/St_Vincent",
  "785": "America/Denver",
  "786": "America/New_York",
  "787": "America/Puerto_Rico",
  "800": "America/New_York",
  "801": "America/Denver",
  "802": "America/New_York",
  "803": "America/New_York",
  "804": "America/New_York",
  "805": "America/Los_Angeles",
  "806": "America/Chicago",
  "807": "America/New_York",
  "808": "Pacific/Honolulu",
  "809": "America/Santo_Domingo",
  "810": "America/Detroit",
  "812": "America/Kentucky/Louisville",
  "813": "America/New_York",
  "814": "America/New_York",
  "815": "America/Chicago",
  "816": "America/Chicago",
  "817": "America/Chicago",
  "818": "America/Los_Angeles",
  "819": "America/New_York",
  "828": "America/New_York",
  "829": "America/Santo_Domingo",
  "830": "America/Chicago",
  "831": "America/Los_Angeles",
  "832": "America/Chicago",
  "835": "America/New_York",
  "843": "America/New_York",
  "845": "America/New_York",
  "847": "America/Chicago",
  "848": "America/New_York",
  "849": "America/Santo_Domingo",
  "850": "America/New_York",
  "855": "America/New_York",
  "856": "America/New_York",
  "857": "America/New_York",
  "858": "America/Los_Angeles",
  "859": "America/Kentucky/Louisville",
  "860": "America/New_York",
  "862": "America/New_York",
  "863": "America/New_York",
  "864": "America/New_York",
  "865": "America/New_York",
  "866": "America/New_York",
  "867": "America/New_York",
  "868": "America/Port_of_Spain",
  "869": "America/St_Kitts",
  "870": "America/Chicago",
  "872": "America/Chicago",
  "876": "America/Jamaica",
  "877": "America/New_York",
  "878": "America/New_York",
  "888": "America/New_York",
  "901": "America/Chicago",
  "902": "America/New_York",
  "903": "America/Chicago",
  "904": "America/New_York",
  "905": "America/New_York",
  "906": "America/Detroit",
  "907": "America/Anchorage",
  "908": "America/New_York",
  "909": "America/Los_Angeles",
  "910": "America/New_York",
  "912": "America/New_York",
  "913": "America/Chicago",
  "914": "America/New_York",
  "915": "America/Chicago",
  "916": "America/Los_Angeles",
  "917": "America/New_York",
  "918": "America/Chicago",
  "919": "America/New_York",
  "920": "America/Chicago",
  "925": "America/Los_Angeles",
  "927": "America/New_York",
  "928": "America/Phoenix",
  "931": "America/Chicago",
  "935": "America/Los_Angeles",
  "936": "America/Chicago",
  "937": "America/New_York",
  "939": "America/Puerto_Rico",
  "940": "America/Chicago",
  "941": "America/New_York",
  "947": "America/Detroit",
  "949": "America/Los_Angeles",
  "951": "America/Los_Angeles",
  "952": "America/Chicago",
  "954": "America/New_York",
  "956": "America/Chicago",
  "957": "America/Denver",
  "959": "America/New_York",
  "970": "America/Denver",
  "971": "America/Los_Angeles",
  "972": "America/Chicago",
  "973": "America/New_York",
  "975": "America/Chicago",
  "978": "America/New_York",
  "979": "America/Chicago",
  "980": "America/New_York",
  "984": "America/New_York",
  "985": "America/Chicago",
  "989": "America/Detroit"
}

// Converts America/New_York to -5 for example
export const TimezoneToUtcDiff = (timeZone: string) => {
  const now = new Date();
  const utcTime = now.getTime();
  const localTime = new Date(now.toLocaleString("en-US", { timeZone })).getTime();
  return (localTime - utcTime) / (1000 * 60 * 60); // hours
}

// #########################################################

export interface CountryCode {
  code: string; // ISO 3166-1 alpha-2 code
  name: string; // Country name
  dialCode: string; // Phone dial code with +
}

export interface PhoneInputProps extends Omit<MuiTextFieldProps, 'name' | 'onChange' | 'onBlur' | 'value' | 'error'> {
  field: FormFieldApi<string>;
  name: string;
  defaultCountry?: string; // ISO 3166-1 alpha-2 code
}

// Generate the country codes from the constants
const generateCountryCodes = (): CountryCode[] => {
  const codes: CountryCode[] = [];

  Object.entries(COUNTRY_NAMES).forEach(([code, name]) => {
    // Only add countries that have a phone code
    const phoneCode = COUNTRY_PHONE_CODES[code as keyof typeof COUNTRY_PHONE_CODES];
    if (phoneCode) {
      codes.push({
        code,
        name,
        dialCode: phoneCode.startsWith('+') ? phoneCode : `+${phoneCode}`
      });
    }
  });

  // Sort by country name
  return codes.sort((a, b) => a.name.localeCompare(b.name));
};

// Generate countries once
const ALL_COUNTRY_CODES = generateCountryCodes();

// Memoized country list item component to prevent unnecessary re-renders
const CountryListItem = memo(({
  country,
  selectedCountry,
  onCountryClick
}: {
  country: CountryCode;
  selectedCountry: string;
  onCountryClick: (code: string, dialCode: string) => void;
}) => (
  <ListItemButton
    key={country.code}
    selected={selectedCountry === country.code}
    onClick={() => onCountryClick(country.code, country.dialCode)}
    sx={{ padding: 1 }}
  >
    <ListItemIcon sx={{ minWidth: 36 }}>
      <Box
        component="span"
        className={`fi fi-${country.code.toLowerCase()}`}
        sx={{
          width: 24,
          height: 18,
          borderRadius: 0.5,
          display: 'inline-block'
        }}
      />
    </ListItemIcon>
    <ListItemText
      primary={country.name}
      secondary={country.dialCode}
      sx={{ margin: 0 }}
      primaryTypographyProps={{
        variant: 'body2',
        noWrap: true
      }}
    />
  </ListItemButton>
));

/**
 * PhoneInput component that integrates with TanStack Form and displays country flags
 */
export const PhoneInput = ({
  field,
  name,
  helperText,
  defaultCountry = 'gb',
  ...props
}: PhoneInputProps) => {
  const { state, getMeta } = field;
  const meta = getMeta();

  // Memoize error values to prevent unnecessary re-renders
  const error = useMemo(() => meta.touchedErrors.length > 0, [meta.touchedErrors]);
  const errorMessage = useMemo(() => meta.touchedErrors[0] as string | undefined, [meta.touchedErrors]);

  // Country selection
  const [anchorEl, setAnchorEl] = useState<HTMLDivElement | null>(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedCountry, setSelectedCountry] = useState<string>(() => {
    // Find the default country code
    const country = ALL_COUNTRY_CODES.find((c) => c.code.toLowerCase() === defaultCountry.toLowerCase());
    return country ? country.code : 'gb';
  });

  const selectedCountryDetails = useMemo(() =>
    ALL_COUNTRY_CODES.find((c) => c.code.toLowerCase() === selectedCountry.toLowerCase()),
    [selectedCountry]
  );

  const filteredCountries = useMemo(() => {
    if (!searchTerm) return ALL_COUNTRY_CODES;
    const lowerSearch = searchTerm.toLowerCase();
    return ALL_COUNTRY_CODES.filter(
      (country) =>
        country.name.toLowerCase().includes(lowerSearch) ||
        country.dialCode.includes(searchTerm) ||
        country.code.toLowerCase().includes(lowerSearch)
    );
  }, [searchTerm]);

  const handleCountryClick = useCallback((code: string, dialCode: string) => {
    setSelectedCountry(code);

    // Extract the phone number part (without the country code)
    const currentValue = state.value || '';
    // If the value contains any dial code, remove it
    const phoneNumberOnly = currentValue.replace(/^\+[0-9\-\s]+/, '').trim();

    // Set the new value with the selected country code
    field.handleChange(`${dialCode} ${phoneNumberOnly}`);
    setAnchorEl(null);
    setSearchTerm('');
  }, [state.value, field]);

  const handlePhoneChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    // Keep the selected country code at the beginning
    const dialCode = selectedCountryDetails?.dialCode || '';
    const newValue = e.target.value;

    // Make sure the dial code is preserved
    if (newValue.startsWith(dialCode)) {
      field.handleChange(newValue);
    } else {
      // If dial code was removed, add it back
      const phoneNumberOnly = newValue.replace(/^\+[0-9\-\s]+/, '').trim();
      field.handleChange(`${dialCode} ${phoneNumberOnly}`);
    }
  }, [selectedCountryDetails, field]);

  const handleClickOpen = useCallback((event: React.MouseEvent<HTMLDivElement>) => {
    setAnchorEl(event.currentTarget);
  }, []);

  const handleClose = useCallback(() => {
    setAnchorEl(null);
    setSearchTerm('');
  }, []);

  const handleSearchChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(e.target.value);
  }, []);

  const handleBlur = useCallback(() => {
    field.handleBlur();
  }, [field]);

  const open = Boolean(anchorEl);

  // Memoize input props to prevent unnecessary re-renders
  const inputProps = useMemo(() => ({
    startAdornment: (
      <InputAdornment position="start">
        <Box
          onClick={handleClickOpen}
          sx={{
            display: 'flex',
            alignItems: 'center',
            cursor: 'pointer',
            '&:hover': { opacity: 0.8 }
          }}
        >
          <Box
            component="span"
            className={`fi fi-${selectedCountry.toLowerCase()}`}
            sx={{
              width: 24,
              height: 18,
              borderRadius: 0.5,
              mr: 1,
              display: 'inline-block'
            }}
          />
          <CaretDownIcon size={16} color="action" />
        </Box>
      </InputAdornment>
    )
  }), [selectedCountry, handleClickOpen]);

  // Memoize popover props to prevent unnecessary re-renders
  const popoverProps = useMemo(() => ({
    open,
    anchorEl,
    onClose: handleClose,
    anchorOrigin: {
      vertical: 'bottom' as const,
      horizontal: 'left' as const,
    },
    PaperProps: {
      sx: { width: 320 }
    }
  }), [open, anchorEl, handleClose]);

  return (
    <>
      <MuiTextField
        name={name}
        value={state.value || ''}
        onChange={handlePhoneChange}
        onBlur={handleBlur}
        error={error}
        helperText={error ? errorMessage : helperText}
        fullWidth
        InputProps={inputProps}
        {...props}
      />

      <Popover {...popoverProps}>
        <Stack direction="column" spacing={1} p={2}>
          <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
            <MagnifyingGlassIcon size={16} color="action" />
            <InputBase
              placeholder="Search country..."
              value={searchTerm}
              onChange={handleSearchChange}
              fullWidth
            />
          </Box>
          <Divider />
          <VirtualizedList
            data={filteredCountries}
            height={350}
            renderItem={(item, index) => {
              // Explicitly cast the item to CountryCode
              const typedCountry = item as CountryCode;
              return (
                <CountryListItem
                  key={typedCountry.code}
                  country={typedCountry}
                  selectedCountry={selectedCountry}
                  onCountryClick={handleCountryClick}
                />
              );
            }}
            emptyComponent={
              <ListItemText
                sx={{ textAlign: 'center' }}
                primary="No countries found"
              />
            }
          />
        </Stack>
      </Popover>
    </>
  );
}; 